import React from 'react'
import NotificationCenterContext from './NotificationCenterContext'

export default function useNotificationCenter () {
    return React.useContext(NotificationCenterContext)
}